import $ from "jquery";

function TogglePassword() {
    $('#togglePassword').on('click', function() {
        var passwordInput = $('#password');
        var toggleIcon = $('#toggleIcon');

        // Check the type of the input and toggle it
        if (passwordInput.attr('type') === 'password') {
            passwordInput.attr('type', 'text');
            toggleIcon.removeClass('fa-eye').addClass('fa-eye-slash');
        } else {
            passwordInput.attr('type', 'password');
            toggleIcon.removeClass('fa-eye-slash').addClass('fa-eye');
        }
    });
}

export default TogglePassword;